<template>
    <div class="nevs-content">
        <div :class="{'message': true, 'message-unseen': !message.seen}" v-for="(message, key) in messages" :key="key">
            <NevsButton @click="openMessage(message.id)"><i class="fa-solid fa-envelope-open"></i> {{ $LANG.Get('buttons.openMessage') }}</NevsButton>
            &nbsp;&nbsp;&nbsp;
            <span v-if="!message.seen">{{ $LANG.Get('labels.newMessage') }} - </span>
            {{ message.title }}
            <span class="message-time">({{ message.time_display }})</span>
        </div>
    </div>
</template>

<script>

import NevsButton from "@/components/nevs/NevsButton.vue";

export default {
    name: "ModuleMessages",
    components: {NevsButton},
    data() {
        return {
            messages: []
        }
    },
    watch: {},
    methods: {
        openMessage(messageId)
        {
            this.$router.push('/messages/' + messageId);
        }
    },
    mounted() {
        this.$store.commit('selectMenu', null);
        this.$store.commit('selectSubMenu', null);
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.messages'),
                link: null
            }
        ]);

        let vm = this;
        this.$API.APICall('get', 'messages', {}, (data, success) => {
            if (success) {
                vm.messages = data.messages;
            }
        });
    }
}
</script>

<style scoped>
    .message {
        background: white;
        border-radius: 10px;
        padding: 10px;
        margin-bottom: 10px;
    }

    .message-unseen {
        background: #FFAC1C;
    }

    .message-time {
        font-style: italic;
        font-size: 12px;
    }
</style>